"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("./icons");
var Button_1 = require("./Button");
function LinkButton(_a) {
    var _b = _a.endIcon, endIcon = _b === void 0 ? 'arrow' : _b, children = _a.children, props = __rest(_a, ["endIcon", "children"]);
    var buttonCss = (0, Button_1.useButtonCss)({});
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, __assign({ css: buttonCss }, props, { children: [children, endIcon === 'arrow' ? (0, jsx_runtime_1.jsx)(icons_1.ArrowRightIcon, { css: { marginLeft: 8, stroke: 'white' } }) : { endIcon: endIcon }] })));
}
exports.default = LinkButton;
